import { ColorFilterProps } from "../../types/imageStudio/images";

export const colorFilterList: ColorFilterProps[] = [
    {
        name: 'No Filter',
        type: 'default',
        contrast: 0,
        whiteness: 0,
        temperature: 0,
        tint: 0,
        brightness: 0,
        sharpness: 0,
        highlights: 0,
        saturation: 0,
        clarity: 0,
        vibrance: 0,
        vignetting: 0,
        shadow: 0
    },
    {
        name: 'Fresco',
        type: 'natural',
        contrast: 5,
        whiteness: 0,
        temperature: 0,
        tint: 0,
        brightness: 10,
        highlights: 0,
        saturation: 30,
        sharpness: 0,
        clarity: 0,
        vignetting: 10,
        vibrance:  40,
        shadow: 0
    },
    {
        name: 'Belvedere',
        type: 'natural',
        contrast: 20,
        whiteness: 0,
        temperature: -10,
        tint: 20,
        brightness: 10,
        highlights: 10,
        saturation: 40,
        sharpness: 0,
        clarity: 0,
        vignetting: 15,
        vibrance:  60,
        shadow: -10
    },
    {
        name: 'Polaroid',
        type: 'vintage',
        contrast: -20,
        whiteness: 0,
        temperature: 10,
        tint: 0,
        brightness: -20,
        highlights: -10,
        saturation: 20,
        sharpness: 0,
        clarity: 0,
        vignetting: 80,
        vibrance:  20,
        shadow: -20
    },
    {
        name: 'Classic',
        type: 'mono',
        contrast: 0,
        whiteness: 20,
        temperature: 10,
        tint: 0,
        brightness: -10,
        highlights: 60,
        saturation: -100,
        sharpness: 10,
        clarity: -10,
        vignetting: 10,
        vibrance:  -100,
        shadow: -25
    },
    {
        name: 'Pop-Art',
        type: 'party',
        contrast: 60,
        whiteness: -50,
        temperature: -15,
        tint: 100,
        brightness: 50,
        highlights: 5,
        saturation: 100,
        sharpness: 80,
        clarity: 50,
        vignetting: -90,
        vibrance:  100,
        shadow: -100
    }
]